export default __webpack_public_path__ + "static/media/speakers.aba36b49.jpg";